import styled from 'styled-components';

export const UserImgContainer = styled.div`
  border-radius: 50%;
  overflow: hidden;
`;

export const UserImg = styled.img`
  width: 103px;
  height: 103px;
`;
